/* Enord Core classic v1.0 — smooth scroll for in-page anchor buttons (offset from data-eil-offset) */
(function(){
  document.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[data-eil-scroll]');
    if(!a)return;
    var h=a.getAttribute('href')||'';
    if(h.charAt(0)!=='#'||h.length<2)return;
    var t=document.getElementById(h.slice(1));
    if(!t)return;
    e.preventDefault();
    var off=parseInt(a.getAttribute('data-eil-offset'),10)||0;
    window.scrollTo({top:t.getBoundingClientRect().top+window.pageYOffset-off,behavior:'smooth'});
  });
})();
